module.exports = __webpack_public_path__ + "static/feature-phone-mobile-2-ba8d6ec57f613d3d55ec230bfe000e94.png";